import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Affiliate, HowItWorks, Privacy } from './InfoApp';
import './styles.css';

const component = location.pathname === '/privacy' ? <Privacy/> : location.pathname === '/how-it-works' ? <HowItWorks/> : location.pathname === '/affiliate' ? <Affiliate/> : <App/>;
createRoot(document.getElementById('root')!).render(<StrictMode>{component}</StrictMode>);
